export default __webpack_public_path__ + "static/media/QOS_WHITE-min.a660e01a.webp";